module.exports = __webpack_public_path__ + "static/media/tsugumomo1.0fb102e2.png";